var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--plain",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"content"}},[_c('nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }